import styled from 'styled-components';
import { useState } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';

import AddEventToCalendar from '../../../../components/ui/shared/AddEventToCalendar';
import FontAwesomeIcon from '../../../../components/common/FontAwesomeIcon';

import CommonButton from '../../../../components/common/CommonButton';
import { patchUnregisterClassEvent } from '../../../../redux/api/events/events';

const EventCardFooter = (props) => {
    const {
        value,
        eventDateBegin,
        currentDate,
        handleOpenModal,
        eventDate,
        handleRegister,
        formatEventDateBegin,
        formatCurrentDate,
        eventDateEnd,
        type,
        onUnregisterSuccess,
    } = props;

    const [isUnregistering, setIsUnregistering] = useState(false);
    const userEmail = useSelector((state) => state?.auth?.user?.personal_email);

    const eventDateBeginMoment = moment(eventDateBegin, 'MM/DD/YYYY');
    const eventDateEndMoment = eventDateEnd
        ? moment(eventDateEnd, 'MM/DD/YYYY')
        : null;

    const isPastEvent = eventDateBeginMoment.isBefore(currentDate);

    const isEventAvailableAndNotRegistered =
        !value.is_registered && eventDate >= currentDate;

    const isEventAvailableOrTodayAndRegistered =
        !!value.is_registered && formatEventDateBegin === formatCurrentDate;

    const isEventAvailableAndRegistered =
        !!value.is_registered &&
        value.registration_url === '' &&
        value.webinar_url !== '' &&
        (eventDateBeginMoment.isSameOrAfter(currentDate) ||
            formatEventDateBegin === formatCurrentDate);

    const isEventURLAvailable =
        value?.webinar_url !== '' &&
        ((eventDateBeginMoment.isBefore(currentDate) &&
            eventDateEndMoment &&
            eventDateEndMoment.isBefore(currentDate)) ||
            formatEventDateBegin === formatCurrentDate) &&
        value?.webinar_url?.toLowerCase()?.includes('www.aden.org');

    const isClassRegisteredBeforeStart =
        type === 'class' &&
        value.is_registered &&
        eventDateBeginMoment.isAfter(currentDate);

    const handleUnregister = async () => {
        const body = {
            state: 'cancel',
            email: userEmail,
        };

        setIsUnregistering(true);
        try {
            const response = await patchUnregisterClassEvent(value.id, body);
            if (response.error) {
                console.error('Error al desinscribirse:', response.error);
            } else {
                if (onUnregisterSuccess) {
                    onUnregisterSuccess();
                } else {
                    window.location.reload();
                }
            }
        } catch (error) {
            console.error('Error al desinscribirse:', error);
        } finally {
            setIsUnregistering(false);
        }
    };

    const handleOpenWebinaURL = () => {
        if (value.webinar_url.toLowerCase().includes('http')) {
            window.open(value.webinar_url, '_blank');
            return;
        } else {
            window.open(`https://${value.webinar_url}`, '_blank');
        }
    };

    return (
        <Footer>
            {!!value.webinar_url && (
                <>
                    {isPastEvent ? (
                        <ActionButton
                            onClick={() =>
                                handleOpenModal(
                                    value.webinar_url,
                                    value.crm_id,
                                    value.publication_name,
                                    'evento-pasado'
                                )
                            }
                        >
                            <FontAwesomeIcon
                                icon="fa-light fa-share-nodes"
                                size={24}
                                color={'#b31d15'}
                            />
                        </ActionButton>
                    ) : (
                        <ActionsContainer>
                            <ActionButton
                                onClick={() =>
                                    handleOpenModal(
                                        value.webinar_url,
                                        value.crm_id,
                                        value.publication_name,
                                        'evento-actual'
                                    )
                                }
                            >
                                <FontAwesomeIcon
                                    icon="fa-light fa-share-nodes"
                                    size={24}
                                    color={'#b31d15'}
                                />
                            </ActionButton>
                            <AddEventToCalendar oneEvent={value} />
                        </ActionsContainer>
                    )}
                </>
            )}
            {isClassRegisteredBeforeStart && (
                <CommonButton
                    onClick={handleUnregister}
                    variant="filled"
                    label={
                        isUnregistering
                            ? 'Desinscribiendo...'
                            : 'Desinscribirse'
                    }
                    disabled={isUnregistering}
                />
            )}
            {!isClassRegisteredBeforeStart &&
                isEventAvailableAndNotRegistered && (
                    <CommonButton
                        onClick={handleRegister}
                        variant="filled"
                        label="Inscribirme"
                    />
                )}
            {!isClassRegisteredBeforeStart &&
            isEventAvailableOrTodayAndRegistered ? (
                <CommonButton
                    onClick={handleRegister}
                    variant="filled"
                    label="Ingresar al evento"
                />
            ) : !isClassRegisteredBeforeStart &&
              isEventAvailableAndRegistered ? (
                <CommonButton
                    onClick={handleRegister}
                    variant="filled"
                    label="Ver evento"
                />
            ) : !isClassRegisteredBeforeStart && isEventURLAvailable ? (
                <CommonButton
                    onClick={handleOpenWebinaURL}
                    variant="filled"
                    label="Volver a ver"
                />
            ) : null}
        </Footer>
    );
};

export default EventCardFooter;

const Footer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    border-top: 1px solid #fafafa;
    margin-top: auto;
    background-color: #f1f1f1;
    @media (max-width: 768px) {
        margin-top: 1rem;
    }
`;

const ActionsContainer = styled.div`
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 0.5rem;
`;

const ActionButton = styled.button`
    cursor: pointer;
    width: 44px;
    height: 44px;
    border-radius: 100px;
    border: 1px solid #b31d15;

    &:hover {
        background-color: #b31d15;

        svg {
            color: #fff !important;
        }
    }
`;
